/** H5：触发浏览器下载 */
export function downloadBlobInBrowser(blob: Blob, filename: string) {
  const name = filename.includes(".") ? filename : `${filename}.png`
  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement("a")
    link.href = url
    link.download = name
    link.style.display = "none"
    document.body.appendChild(link)
    link.click()
    link.remove()
  } finally {
    window.setTimeout(() => URL.revokeObjectURL(url), 2000)
  }
}

export async function downloadFileInBrowser(url: string, filename?: string) {
  const name =
    filename ||
    url
      .split("?")[0]
      .split("#")[0]
      .split("/")
      .pop() ||
    `download_${Date.now()}.png`

  if (url.startsWith("blob:") || url.startsWith("data:")) {
    const link = document.createElement("a")
    link.href = url
    link.download = name.includes(".") ? name : `${name}.png`
    link.rel = "noopener"
    document.body.appendChild(link)
    link.click()
    link.remove()
    return true
  }

  try {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`文件下载失败 (${res.status})`)
    const blob = await res.blob()
    if (blob.size <= 0) throw new Error("文件下载失败或文件为空")

    const blobUrl = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = blobUrl
    link.download = name
    link.rel = "noopener"
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
    return true
  } catch {
    const link = document.createElement("a")
    link.href = url
    link.download = name
    link.target = "_blank"
    link.rel = "noopener noreferrer"
    document.body.appendChild(link)
    link.click()
    link.remove()
    return true
  }
}
